import script from "./ContactInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInfo.vue?vue&type=script&setup=true&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=443f1520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443f1520"]])

export default __exports__